@let it = item();

@if (isLink(it) && !isFunction(it.route)) {
  <a
    [class.hover:bg-hover]="!(isActive$ | async)?.(it)"
    [ngClass]="{
      'bg-primary-600 text-on-primary-600': $safeNavigationMigration(
        (isActive$ | async)?.(it)
      ),
      'navigation-color': !(isActive$ | async)?.(it)
    }"
    [routerLink]="it.route"
    class="navigation-item"
    matRipple>
    {{ it.label | translate }}
  </a>
}

@if (isLink(it) && isFunction(it.route)) {
  <div
    (click)="$any(it.route)()"
    (keydown.enter)="$any(it.route)()"
    [class.hover:bg-hover]="!(isActive$ | async)?.(it)"
    class="navigation-item navigation-color"
    matRipple
    tabindex="0">
    {{ it.label | translate }}
  </div>
}

@if ((isSubheading(it) && it.children.length > 0) || isDropdown(it)) {
  <div
    [class.hover:bg-hover]="!(isActive$ | async)?.(it)"
    [matMenuTriggerFor]="menu"
    [ngClass]="{
      'bg-primary-600 text-on-primary-600': $safeNavigationMigration(
        (isActive$ | async)?.(it)
      ),
      'navigation-color': !(isActive$ | async)?.(it)
    }"
    class="navigation-item"
    matRipple>
    {{ it.label | translate }}
  </div>
  <mat-menu #menu="matMenu" yPosition="below">
    @for (child of $any(it).children; track child) {
      @if (isLink(child) && !isFunction(child.route)) {
        <a
          [ngClass]="{
            'text-primary-600': $safeNavigationMigration(
              (isActive$ | async)?.(child)
            )
          }"
          [routerLink]="child.route"
          class="navigation-menu-item"
          mat-menu-item>
          @if (child.icon) {
            <mat-icon [svgIcon]="child.icon" class="text-current"></mat-icon>
          }
          <span>{{ child.label }}</span>
        </a>
      }
      @if (isLink(child) && isFunction(child.route)) {
        <div
          (click)="$any(child.route)()"
          (keydown.enter)="$any(child.route)()"
          class="navigation-menu-item"
          mat-menu-item
          tabindex="0">
          @if (child.icon) {
            <mat-icon [svgIcon]="child.icon" class="text-current"></mat-icon>
          }
          <span>{{ child.label }}</span>
        </div>
      }
      @if (isDropdown(child)) {
        <button
          [matMenuTriggerFor]="level1"
          [ngClass]="{
            'text-primary-600': $safeNavigationMigration(
              (isActive$ | async)?.(child)
            )
          }"
          class="navigation-menu-item"
          mat-menu-item>
          @if (child.icon) {
            <mat-icon [svgIcon]="child.icon" class="text-current"></mat-icon>
          }
          <span>{{ child.label }}</span>
        </button>
        <mat-menu #level1="matMenu" yPosition="below">
          @for (item of child.children; track item) {
            <ng-container
              [ngTemplateOutletContext]="{ item: item }"
              [ngTemplateOutlet]="linkTemplate"></ng-container>
            @if (isDropdown(item)) {
              <button
                [matMenuTriggerFor]="level2"
                [ngClass]="{
                  'text-primary-600': $safeNavigationMigration(
                    (isActive$ | async)?.(item)
                  )
                }"
                class="navigation-menu-item"
                mat-menu-item>
                {{ item.label | translate }}
              </button>
              <mat-menu #level2="matMenu" yPosition="below">
                @for (child of item.children; track child) {
                  <ng-container
                    [ngTemplateOutletContext]="{ item: child }"
                    [ngTemplateOutlet]="linkTemplate"></ng-container>
                  @if (isDropdown(child)) {
                    <button
                      [matMenuTriggerFor]="level3"
                      [ngClass]="{
                        'text-primary-600': $safeNavigationMigration(
                          (isActive$ | async)?.(child)
                        )
                      }"
                      class="navigation-menu-item"
                      mat-menu-item>
                      {{ child.label }}
                    </button>
                    <mat-menu #level3="matMenu" yPosition="below">
                      @for (item of child.children; track item) {
                        <ng-container
                          [ngTemplateOutletContext]="{ item: item }"
                          [ngTemplateOutlet]="linkTemplate"></ng-container>
                        @if (isDropdown(item)) {
                          <button
                            [matMenuTriggerFor]="level4"
                            [ngClass]="{
                              'text-primary-600': $safeNavigationMigration(
                                (isActive$ | async)?.(item)
                              )
                            }"
                            class="navigation-menu-item"
                            mat-menu-item>
                            {{ item.label | translate }}
                          </button>
                          <mat-menu #level4="matMenu" yPosition="below">
                            @for (child of item.children; track child) {
                              <ng-container
                                [ngTemplateOutletContext]="{ item: child }"
                                [ngTemplateOutlet]="
                                  linkTemplate
                                "></ng-container>
                              @if (isDropdown(child)) {
                                <button
                                  [matMenuTriggerFor]="level5"
                                  [ngClass]="{
                                    'text-primary-600':
                                      $safeNavigationMigration(
                                        (isActive$ | async)?.(child)
                                      )
                                  }"
                                  class="navigation-menu-item"
                                  mat-menu-item>
                                  {{ child.label }}
                                </button>
                                <mat-menu #level5="matMenu" yPosition="below">
                                  @for (item of child.children; track item) {
                                    <ng-container
                                      [ngTemplateOutletContext]="{ item: item }"
                                      [ngTemplateOutlet]="
                                        linkTemplate
                                      "></ng-container>
                                  }
                                </mat-menu>
                              }
                            }
                          </mat-menu>
                        }
                      }
                    </mat-menu>
                  }
                }
              </mat-menu>
            }
          }
        </mat-menu>
      }
    }
  </mat-menu>
  <ng-template #linkTemplate let-item="item">
    @if (isLink(item) && !isFunction(item.route)) {
      <a
        [ngClass]="{
          'text-primary-600': $safeNavigationMigration(
            (isActive$ | async)?.(item)
          )
        }"
        [routerLink]="item.route"
        class="navigation-menu-item"
        mat-menu-item
        >{{ item.label | translate }}</a
      >
    }
    @if (isLink(item) && isFunction(item.route)) {
      <div
        (click)="$any(item.route)()"
        (keydown.enter)="$any(item.route)()"
        [ngClass]="{
          'text-primary-600': $safeNavigationMigration(
            (isActive$ | async)?.(item)
          )
        }"
        class="navigation-menu-item"
        mat-menu-item
        tabindex="0">
        {{ item.label | translate }}
      </div>
    }
  </ng-template>
}
